//
// Warning.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "./WarningLevel";

var Warning = createModule("commons::Warning", [], ClosetObject, [
    {
        SEVERITY_FATAL_MAX: 100.0,
        SEVERITY_WARNING_DEFAULT: 60.0,
        SEVERITY_ERROR_MIN: 70.0,
        SEVERITY_INFO_DEFAULT: 30.0,
        SEVERITY_WARNING_MAX: 69.99999,
        INVALID_TYPE: 10033,
        SEVERITY_INFO_MIN: 0.0,
        SEVERITY_ERROR_DEFAULT: 80.0,
        DEBUG_WARNING: 10034,
        SEVERITY_ERROR_MAX: 89.99999,
        SEVERITY_FATAL_MIN: 90.0,
        SEVERITY_INFO_MAX: 39.99999,
        SEVERITY_WARNING_MIN: 40.0,
        SEVERITY_FATAL_DEFAULT: 95.0,
    },
    ,
    ,
    {
        severity: 6,
    },
    {
        getLevel: [4],
        getTemplateParameters: [[7]],
        getWarningTypeName: [7],
        getMessage: [7],
        getWarningType: [4],
        getMessageTemplate: [7],
    },
    {
        _create_nns: [4,4,4,7],
        _create_nnso: [4,4,4,7,[7]],
        sortWarningsDescendingBySeverity: [[1],[1]],
    },
    ,
    ["_create"]
]);
export default Warning;
